import { TRootState } from '../reducers';
import { DealerOfferParams } from '../reducers/types';

interface OrigParams {
  origPageName: string;
  origPlatform: string;
}

export const selectOrigParams = (state: TRootState): OrigParams => {
  return {
    origPlatform: state.meta.origPlatform,
    origPageName: state.meta.origPageName,
  };
};

export const selectDealerOfferParams = (state: TRootState): DealerOfferParams | undefined => {
  return state.meta.dealerOfferParams;
};

export const selectIntentId = (state: TRootState): string | undefined => {
  return state.meta.intentId;
};

export const selectMainOptionName = (state: TRootState): string | undefined => {
  return state.meta.mainOptionName;
};

export const selectLoadPageUrl = (state: TRootState): string => {
  return state.meta.loadPageUrl;
};

export const selectReferral = (state: TRootState): string | undefined => {
  return state.meta.referral;
};

export const selectIsCopilotInitialized = (state: TRootState): boolean | undefined => {
  return state.meta.isCopilotInitialized;
};

export const selectIsCopilotChatbotVisible = (state: TRootState): boolean | undefined => {
  return state.meta.isCopilotChatbotVisible;
};

export const selectSuggestedQuestions = (state: TRootState): string[] | undefined => {
  return state.meta.suggestedQuestions;
};
